import { useEffect } from 'react';
import { buildSiteColorVariables } from '../context/theme/utils';
import { DEFAULT_PRIMARY_COLOR, DEFAULT_SECONDARY_COLOR, DEFAULT_TERTIARY_COLOR } from '../constants';
import { useTheme } from '../context/theme/useTheme';

export const useSiteColors = (primary?: string, secondary?: string, tertiary?: string) => {
  const { isDarkMode } = useTheme();

  useEffect(() => {
    const allVariables = buildSiteColorVariables(
      primary || DEFAULT_PRIMARY_COLOR,
      secondary || DEFAULT_SECONDARY_COLOR,
      tertiary || DEFAULT_TERTIARY_COLOR,
      isDarkMode
    );

    Object.entries(allVariables).forEach(([key, value]) => {
      document.body.style.setProperty(key, value);
    });
  }, [primary, secondary, tertiary, isDarkMode]);
};
